import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useUserRole = () => {
  let userrole = useSelector((state) => state.auth.user?.role);
  let permissions = useSelector((state) => state.auth.user?.permissions);
  let tenantType = useSelector((state) => state.auth.user?.type);
  const accessToken = localStorage.getItem("kinesin-accessToken");

  if (accessToken && (!userrole || !permissions || !tenantType)) {
    try {
      const decoded = JSON.parse(window.atob(accessToken.split(".")[1]));
      if (!userrole) userrole = decoded.role;
      if (!permissions) permissions = decoded.permissions;
      if (!tenantType) tenantType = decoded.tenantType;
    } catch (e) {
      // Ignore decode errors
    }
  }

  const isAdmin = userrole && ["ADMIN"].includes(userrole.toUpperCase());

  // Combine role + permissions into a single access list for UI checks
  const accessList = useMemo(() => {
    const list = new Set();
    if (userrole) list.add(userrole.toUpperCase());
    if (Array.isArray(permissions)) {
      permissions.forEach((p) => list.add(p.toUpperCase()));
    }
    return list;
  }, [userrole, permissions]);

  const hasAccess = (requiredRoles) => {
    if (!requiredRoles || requiredRoles.length === 0) return true;
    return requiredRoles.some((role) => accessList.has(role.toUpperCase()));
  };

  return { userrole, isAdmin, permissions, tenantType, accessList, hasAccess };
};
